import React, { useCallback } from 'react';
import tw from 'twin.macro';
import Checkbox from '~/src/atoms/Checkbox';
import useSelectedPack from './useSelectedPack';

const ProductSelection = ({ handleSKUSelection, isSKUSelected }) => {
  const { id } = useSelectedPack();

  const hanldeSelection = useCallback(
    (e) => {
      e.stopPropagation();
      handleSKUSelection({ type: 'sku', payload: { id, isSelected: e.target.checked } });
    },
    [id]
  );

  return (
    <div className={`absolute w-25 h-25 rounded-left rounded-xs flex justify-end bg-selectionLight`} style={{ top: '-11px', right: '-11px' }}>
      <div className="mt-1 mr-1 w-6 h-6">
        <Checkbox
          checked={isSKUSelected}
          css={tw`checked:bg-darkOnyx-800 checked:border-white hover:border-white`}
          className="rounded w-5 h-5 z-max bg-darkOnyx-100 border-white"
          onClick={hanldeSelection}
        />
      </div>
    </div>
  );
};

export default ProductSelection;
